module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div style=\"padding:20px\" class=\"tour-overlay\">  </div>\r\n\r\n<div class=\"tour-step\" style=\"display: none;\">\r\n    <div class=\"step-title\">\r\n        <span class=\"text\"></span>\r\n        <span class=\"tour-close-button top-right\" title=\"Close Tour\"></span>\r\n    </div>\r\n    <div class=\"step-content\"></div>\r\n    <div class=\"step-navigation\">\r\n        <div class=\"tour-button back\">\r\n            &lt;&lt; Back\r\n        </div>\r\n        <div class=\"tour-button next\">\r\n             Next &gt;&gt;\r\n        </div>\r\n    </div>\r\n    <div class=\"step-footer\"></div>\r\n    <div class=\"step-arrow arrow-right\" style=\"display: none;\">\r\n        <img src=\"")
    ; __append( require('tours/arrow-right.svg'))
    ; __append("\" />\r\n    </div>\r\n    <div class=\"step-arrow arrow-left\" style=\"display: none;\">\r\n        <img src=\"")
    ; __append( require('tours/arrow-left.svg'))
    ; __append("\" />\r\n    </div>\r\n</div>")
  }
  return __output;

}